<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <p
                      style="
                        position: absolute;
                        top: 48px;
                        right: 24px;
                        color: red;
                      "
                      class="validate"
                    >
                      *
                    </p>

                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="EmployeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    ></model-list-select>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <p class="validate">*</p>
                      <label>نوع العمل الإضافي</label>
                      <md-select
                        v-model="overTimeType"
                        :disabled="EmployeeId ? false : true"
                      >
                        <md-option :value="3">عمل إضافي أساسي</md-option>
                        <md-option :value="1">عمل إضافي عادي</md-option>
                        <md-option :value="2">عمل إضافي ممتاز</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>ساعات العمل</label>
                      <md-input v-model="Hours" type="number"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>فيمة الساعة</label>
                      <md-input v-model="ValueHour" type="number"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>المجموع</label>
                      <md-input
                        disabled
                        v-model="SumValue"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <!-- <div class="md-layout-item md-size-30 mt-25 ml-15">
                    <md-datepicker :md-open-on-focus="false" v-model="overTimeDate">
                      <label class="mr-28">تاريخ شهر العمل الإضافي</label>
                    </md-datepicker>
                  </div> -->

                  <div
                    class="md-layout-item md-layout-item-time md-size-30 md-small-size-100 ml-15"
                    style="position: relative"
                  >
                    <h4
                      class="monthly-picker-head"
                      :class="{ active: overTimeDate }"
                    >
                      شهر سداد العمل الإضافي
                    </h4>
                    <vue-monthly-picker
                      class="monthly-picker"
                      alignment="right"
                      v-model="overTimeDate"
                    />
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-datepicker
                      :md-open-on-focus="false"
                      v-model="overTimeDayDate"
                    >
                      <label class="mr-28">تاريخ العمل الإضافي</label>
                    </md-datepicker>
                  </div>

                  <!-- <div class="md-layout-item md-size-35 mt-25 ">
                  <md-checkbox v-model="confirmOverTime"
                    >إعتماد احتساب العمل الاضافي</md-checkbox
                  >
                </div>-->

                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <md-button @click="Save" class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >
                    <md-button @click="clear" class="md-info btn_nanosoft"
                      >جديد</md-button
                    >
                    <md-button
                      class="md-success btn_nanosoft"
                      :disabled="calculateOverTimeLoading"
                      @click="calculateOverTime"
                    >
                      توليد العمل الإضافي

                      <md-progress-spinner
                        v-if="calculateOverTimeLoading"
                        :md-diameter="17"
                        :md-stroke="3"
                        md-mode="indeterminate"
                      />
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">البحث</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout mt-25">
            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <model-list-select
                class="input-must-rtl"
                :list="employees"
                v-model="EmployeeSearch"
                option-value="key"
                option-text="value"
                placeholder="الموظف"
              ></model-list-select>
            </div>

            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <md-datepicker :md-open-on-focus="false" v-model="overtimeFrom">
                <label class="mr-28">تاريخ العمل الإضافي من</label>
              </md-datepicker>
            </div>
            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <md-datepicker :md-open-on-focus="false" v-model="overtimeTo">
                <label class="mr-28">تاريخ العمل الإضافي إلى</label>
              </md-datepicker>
            </div>
          </div>

          <div class="mt-50 md-layout center-content">
            <div
              class="md-layout-item md-size-30 md-small-size-100 center-content ml-15"
            >
              <md-button
                class="md-info btn_nanosoft"
                :disabled="searchLoading"
                @click="Search"
              >
                بحث
                <md-progress-spinner
                  v-if="searchLoading"
                  :md-diameter="17"
                  :md-stroke="3"
                  md-mode="indeterminate"
                />
              </md-button>
              <md-button @click="confirm" class="md-success btn_nanosoft"
                >اعتماد</md-button
              >
              <md-button @click="unConfirm" class="md-danger btn_nanosoft"
                >إلغاء الاعتماد</md-button
              >
            </div>
          </div>

          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-50">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <div v-show="tableData.length > 0" class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-checkbox @change="selectAll" v-model="All"
                >اختيار الكل</md-checkbox
              >
            </div>
          </div>

          <md-table
            :key="indexKey"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell>
                <div class="md-layout-item md-size-20 center-content">
                  <md-checkbox
                    v-model="item.isActive"
                    @change="add(item)"
                  ></md-checkbox>
                </div>
              </md-table-cell>
              <md-table-cell class="w-200" md-label="الموظف">
                {{ item.employeeName }}
              </md-table-cell>
              <md-table-cell
                v-if="item.overTimeType != null"
                md-label="نوع العمل الإضافي"
                >{{ extraWorkDateFilter(item.overTimeType) }}</md-table-cell
              >
              <md-table-cell v-else md-label="نوع العمل الإضافي">
              </md-table-cell>

              <md-table-cell md-label="ساعات العمل">
                {{ item.hours }}
              </md-table-cell>
              <md-table-cell md-label="قيمة الساعة">
                {{ item.valueHour }}
              </md-table-cell>
              <md-table-cell md-label="المجموع">
                {{ item.sumValue }}
              </md-table-cell>
              <md-table-cell md-label="تاريخ العمل الإضافي">
                {{
                  item.overTimeDayDate == null
                    ? "-"
                    : convert(item.overTimeDayDate)
                }}
              </md-table-cell>

              <md-table-cell md-label="حالة العمل الإضافي">
                {{ item.isConfirmed == true ? "معتمد" : "غير معتمد" }}
              </md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      indexKey: 0,
      All: false,
      SelectedEmployees: [],
      isResettingEmployee: true,
      overtimeFrom: null,
      overtimeTo: null,
      errorMessage: "",
      EmployeeId: "",
      EmployeeSearch: null,
      Hours: null,
      ValueHour: null,
      SumValue: null,
      overTimeDate: null,
      overTimeDayDate: null,
      ExtraWorkDayDateS: null,
      ExtraWorkDate_SH: null,
      confirmOverTime: false,
      calculateOverTimeLoading: false,
      searchLoading: false,
      TypeOfOverTime: "true",
      overTimeType: null,
      Selected: [],
      tableData: [],
      btn: "new",
      idTable: "",
      employees: [],
      updateStatus: "",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
    };
  },
  watch: {
    Hours() {
      this.Calcolate();
    },
    ValueHour() {
      this.Calcolate();
    },
    overTimeType(newVal) {
      this.Calcolate();
      this.employeeHourRate();
    },
    async EmployeeId() {
      if (this.isResettingEmployee) {
        this.ValueHour = "";
        this.overTimeType = null;
      }
    },
  },
  methods: {
    selectAll(event) {
      if (event) {
        this.SelectedEmployees = this.tableData.map((item) => item.id);
        this.tableData = this.tableData.map((item) => {
          item.isActive = true;
          return item;
        });
      } else {
        this.SelectedEmployees = [];
        this.tableData = this.tableData.map((item) => {
          item.isActive = false;
          return item;
        });
      }
    },

    add(item) {
      this.indexKey++;
      console.warn("item", item.isActive);
      if (item.isActive) {
        if (!this.SelectedEmployees.includes(item.id)) {
          this.SelectedEmployees = [...this.SelectedEmployees, item.id];
        }
      } else {
        this.SelectedEmployees = this.SelectedEmployees.filter(
          (f) => f != item.id
        );
      }
    },

    async calculateOverTime() {
      try {
        this.calculateOverTimeLoading = true;
        if (!this.overTimeDate) {
          return this.notifyVue(
            "top",
            "center",
            "warning",
            "قم باختيار شهر سداد العمل الإضافي "
          );
        }

        const params = {
          monthDate: moment(this.overTimeDate).format("YYYY-MM-DD"),
        };
        await this.$axios.get("/api/overTime/CalculateOverTime", { params });

        this.notifyVue("top", "center", "success", "تم توليد العمل الإضافي بنجاح");
        this.init();
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      } finally {
        this.calculateOverTimeLoading = false;
      }
    },
    async employeeHourRate() {
      try {
        if (!this.EmployeeId || !this.overTimeType) {
          return;
        }

        const T = localStorage.getItem("Nannotoken");
        const token = atob(T);
        const headers = { Authorization: "Bearer " + token };
        const { data } = await axios.get(
          `${env.HR()}/api/overTime/getHourRate/${this.EmployeeId}`,
          { headers }
        );

        this.ValueHour = data.data;
      } catch (error) {}
    },
    extraWorkDateFilter(type) {
      const overTimeType = {
        1: "عمل إضافي عادي",
        2: "عمل إضافي ممتاز",
        3: "عمل إضافي أساسي",
      };

      return overTimeType[type] || "-";
    },
    Calcolate() {
      let multiplier = 1;
      if (this.overTimeType === 1) {
        multiplier = 1.5;
      } else if (this.overTimeType === 2) {
        multiplier = 2;
      } else if (this.overTimeType === 3) {
        multiplier = 1;
      } else {
        this.SumValue = "";
        return;
      }

      const hours = Number(this.Hours);
      const valueHour = Number(this.ValueHour);

      if (isNaN(hours) || isNaN(valueHour)) {
        this.SumValue = "";
        return;
      }

      this.SumValue = Number((hours * valueHour * multiplier).toFixed(3));
    },
    convert(event) {
      if (!event) {
        return null;
      }
      try {
        const currentDate = new Date(event);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;

        if (isNaN(currentDate.getFullYear()) === true) {
          return "-";
        }
        return formattedDate;
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    ExtraWorkDayDateSChange(e) {
      console.warn("test", e);
      if (!e) {
        this.ExtraWorkDayDateS = null;
      }
    },

    async Search() {
      try {
        this.searchLoading = true;
        // this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        const params = {
          EmployeeId: this.EmployeeSearch,
          overtimeFrom: this.convert(this.overtimeFrom),
          overTimeTo: this.convert(this.overtimeTo),
        };

        let result = await axios.get(`${env.HR()}/api/overTime/filter`, {
          params,
          headers: { Authorization: "Bearer " + token },
        });

        this.tableData = result.data.data;
      } catch (error) {
        this.message(error);
      } finally {
        this.searchLoading = false;
      }
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        if (!this.EmployeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الموظف "
          );
        }

        if (!this.Hours) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال ساعات العمل "
          );
        }

        if (!this.ValueHour) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال قيمة الساعة "
          );
        }

        if (!this.overTimeType) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار نوع العمل الإضافي "
          );
        }

        console.warn("this.overTimeDayDate", this.overTimeDayDate);

        let schema = {
          EmployeeId: this.EmployeeId,
          Hours: this.Hours,
          ValueHour: this.ValueHour,
          overTimeDate: this.convert(this.overTimeDate),
          overTimeDayDate: this.convert(this.overTimeDayDate),
          SumValue: this.SumValue,
          confirmOverTime: this.confirmOverTime,
          overTimeType: Number(this.overTimeType),
        };

        if (this.btn === "new") {
          let result = await axios.post(`${env.HR()}/api/overTime`, schema, {
            headers: { Authorization: "Bearer " + token },
          });
        } else {
          let result = await axios.put(
            `${env.HR()}/api/overTime/${this.idTable}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.btn = "new";
        this.init();
        this.clear(true);
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async confirm() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let schema = {
          // SelectedExtraWorks: this.SelectedEmployees,
          SelectedExtraWorks: this.SelectedEmployees,
        };

        let result = await axios.patch(
          `${env.HR()}/api/overTime/confirm`,
          schema,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.Search();
        // this.tableData = [];
        return this.notifyVue(
          "top",
          "center",
          "success",
          " تم الإعتماد بنجاح "
        );
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    async unConfirm() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let schema = {
          SelectedExtraWorks: this.SelectedEmployees,
        };
        let result = await axios.patch(
          `${env.HR()}/api/overTime/unconfirm`,
          schema,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        if (result.status == 200) {
          this.Search();
          return this.notifyVue(
            "top",
            "center",
            "success",
            result.data.message
          );
        }
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.message
        );
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/overTime`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.employees = result.data.data.employees;
      } catch (error) {
        this.message(error);
      }
    },

    clear(search) {
      if (search) {
        this.Search();
      } else {
        this.tableData = [];
      }
      this.overTimeType = null;
      this.EmployeeId = "";
      this.Hours = "";
      this.ValueHour = "";
      this.SumValue = "";
      this.overTimeDate = null;
      this.overTimeDayDate = null;
      this.confirmOverTime = false;
      this.btn = "new";
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      this.isResettingEmployee = false;

      this.overTimeType = item.overTimeType;
      this.Hours = item.hours;
      this.ValueHour = item.valueHour;
      if (
        item.overTimeDate != "1970-01-01T00:00:00" &&
        item.overTimeDate != null
      ) {
        this.overTimeDate = this.convert(item.overTimeDate);
      }
      if (item.overTimeDayDate != null) {
        this.overTimeDayDate = new Date(item.overTimeDayDate);
      }
      this.confirmOverTime = item.isConfirmed;
      this.btn = "Edit";
      this.idTable = item.id;
      this.EmployeeId = item.employeeId;

      this.$nextTick(() => {
        this.isResettingEmployee = true;
      });
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/overTime/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            this.message(error);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>

<style scoped>
.mt-37 {
  margin-top: 37px;
}
</style>
